module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Gc-Hc-Id-Ja.20e5dc0f.png";